import React from 'react';
import StarIcon from 'components/Icons/StarIcon';
import RectangleSkeleton from 'components/Skeletons/RectangleSkeleton';
import IconSkeleton from 'components/Skeletons/IconSkeleton';
import styles from './DriverReviewsWidget.module.css';

export function SampleSkeleton(): JSX.Element {
    return (
        <div className={styles.sampleSkeleton}>
            <RectangleSkeleton />
            <RectangleSkeleton />
            <RectangleSkeleton />
            <div className={styles.sampleRating}>
                {Array.from({ length: 5 }).map((_, index) => (
                    <IconSkeleton icon={<StarIcon />} key={index} />
                ))}
            </div>
        </div>
    );
}

function SummaryRatingSkeleton(): JSX.Element {
    return (
        <div className={styles.summaryRatingsSkeleton}>
            {Array.from({ length: 5 }).map((_, index) => (
                <RectangleSkeleton key={index} />
            ))}
        </div>
    );
}

function ReasonsSkeleton(): JSX.Element {
    return (
        <div className={styles.reasonsSkeleton}>
            {Array.from({ length: 6 }).map((_, index) => (
                <RectangleSkeleton key={index} />
            ))}
        </div>
    );
}

export function DriverReviewsSkeleton(): JSX.Element {
    return (
        <div className={styles.driverReviewsWidgetSkeleton}>
            <div className={styles.summarySkeleton}>
                <RectangleSkeleton />
                <SummaryRatingSkeleton />
            </div>
            <div className={styles.samplesContainer}>
                <SampleSkeleton />
                <SampleSkeleton />
                <SampleSkeleton />
            </div>
            <ReasonsSkeleton />
        </div>
    );
}

export function DriverReviewsModalSkeleton(): JSX.Element {
    return (
        <div className={styles.driverReviewsModalSkeleton}>
            <div className={styles.leftSection}>
                <RectangleSkeleton />

                <RectangleSkeleton />
                <SummaryRatingSkeleton />
                <ReasonsSkeleton />
            </div>
            <div className={styles.rightSection}>
                <SampleSkeleton />
                <SampleSkeleton />
                <SampleSkeleton />
                <SampleSkeleton />
            </div>
        </div>
    );
}
